<template>
    <div class="card">
        <div class="card-header">Applicant Affirmation</div>
        <div class="card-body">
            <b-row>
                <b-col>
                  I certify the information provided in this application is true and accurate to the best of my knowledge.
                  I have read and will comply with the requirements of the <a href="https://www.revisor.mn.gov/statutes/cite/144A.61" target="_blank">Minnesota Statutes, section 144A.61</a>, and the Code of Federal Regulations, Title 42, Part 483, <a href="https://www.ecfr.gov/current/title-42/section-483.35" target="_blank">Subpart B, section 438.35</a>, and <a href="https://www.ecfr.gov/current/title-42/section-483.156" target="_blank">Subpart D, section 483.156</a>.
                  I understand that knowingly making a false statement on this application could be cause for denial, suspension, or revocation of registration.
                  I understand by signing this document, I give MDH the authority to contact any listed supervisor, employer, and/or client submitted for use in verification of credentials and employment, as well as any other relevant information that determines what is necessary to properly evaluate an applicant for registration.
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" lg="6">
                    <BaseTextInput v-model="affirm.signature"
                                   :v="$v.affirm.signature"
                                   slug="signature"
                                   label="Signature"
                                   setId="sig"/>
                </b-col>
                <b-col cols="12" lg="6">
                    <BaseDateInput v-model="affirm.dateSigned"
                                   :v="$v.affirm.dateSigned"
                                   label="Date"
                                   slug="dateSigned"
                                   :disabled="true"
                                   setId="dtSig"
                                   tip="Format: MM/DD/YYYY"
                    />
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import BaseTextInput from "@/components/templates/input/BaseTextInput"
    import BaseDateInput from "@/components/templates/input/BaseDateInput"
    import { required } from 'vuelidate/lib/validators'

export default {
    components:{
        BaseDateInput,
        BaseTextInput
    },
    data(){
        return {
            affirm: {
                signature: null,
                dateSigned: new Date().toISOString()
            }
        }
    },
    validations(){
        return{
            affirm: {
                signature: {required},
                dateSigned: {required},
            },
            form:['affirm']
        }
    },
    methods:{
        validate(){
            this.$v.form.$touch();
            let isValid = !this.$v.form.$invalid;
            this.$emit('on-validate', this.$data, isValid);
            return isValid;
        },
    },
}
</script>